// extracted by mini-css-extract-plugin
module.exports = {"dateChoice":"DateInputs_dateChoice__9cZdC","addDate":"DateInputs_addDate___24II"};